import type { ClassData } from '@/core/types/library.type'

export interface FilterableMethods {
  /** Sorted, de-duplicated callable member names available for filtering. */
  names: string[]
  /** Whether any of the provided types expose at least one constructor. */
  hasConstructors: boolean
}

/**
 * Collect the callable member names (methods + the constructor token) exposed across a set of
 * types, used to populate the method picker in the wizard.
 */
export function collectFilterableMethods(classes: ClassData[], constructorToken: string): FilterableMethods {
  const names = new Set<string>()
  let hasConstructors = false

  for (const classData of classes) {
    for (const method of Object.values(classData.methods ?? {})) {
      names.add(method.name)
    }

    if (Object.keys(classData.constructors ?? {}).length > 0) {
      hasConstructors = true
    }
  }

  if (hasConstructors) {
    names.add(constructorToken)
  }

  return {
    names: Array.from(names).sort((a, b) => a.localeCompare(b)),
    hasConstructors,
  }
}
